// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qZKzfHN3Hf6Z8V38BX_Q {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 200px;
  row-gap: 0.25rem;
}
.qZKzfHN3Hf6Z8V38BX_Q .pdLS1SWFuicmf7uTX8kk {
  font-size: 0.875rem;
  line-height: 1.0625rem;
  font-weight: 500;
  color: #ededed;
  transition: all 0.3s;
}
.qZKzfHN3Hf6Z8V38BX_Q .ZfTUrMofTNFgwIc25nLN {
  color: #a0a0a0;
  transition: all 0.3s;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN {
  position: relative;
  display: flex;
  width: 100%;
  transition: all 0.3s;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .QcLou3TloqllSwfUynMK {
  background-color: #774dee;
  padding: 0px 8px;
  border-radius: 8px;
  margin-left: 8px;
  font-size: 0.775rem;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9 {
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  width: 100%;
  padding: 8px 13px 8px 15px;
  border: 1px solid #543e79;
  border-radius: 10px;
  background-color: rgba(50, 50, 50, 0.8);
  outline: unset;
  transition: all 0.3s;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:hover {
  transition: all 0.3s;
  cursor: pointer;
  border-color: #6439ab;
  background-color: #2d2d2d;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:hover .BD0VPg9ijoauKEKRiaZS svg {
  transition: all 0.3s;
  fill: #cbcbcb;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:hover .BD0VPg9ijoauKEKRiaZS svg * {
  transition: all 0.3s;
  fill: #cbcbcb;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:hover .LSU0pgvqnZngjNPf_M_w {
  transition: all 0.3s;
  color: #cbcbcb;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:hover > svg {
  transition: all 0.3s;
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:hover > svg * {
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:focus {
  transition: all 0.3s;
  cursor: pointer;
  border-color: #8d56e8;
  background-color: #2d2d2d;
  outline: unset;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:focus .BD0VPg9ijoauKEKRiaZS svg {
  transition: all 0.3s;
  fill: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:focus .BD0VPg9ijoauKEKRiaZS svg * {
  transition: all 0.3s;
  fill: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:focus .LSU0pgvqnZngjNPf_M_w {
  transition: all 0.3s;
  color: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:focus > svg {
  transition: all 0.3s;
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:focus > svg * {
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:active {
  transition: all 0.3s;
  cursor: pointer;
  border-color: #543e79;
  background-color: rgba(50, 50, 50, 0.8);
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:active .BD0VPg9ijoauKEKRiaZS svg {
  transition: all 0.3s;
  fill: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:active .BD0VPg9ijoauKEKRiaZS svg * {
  transition: all 0.3s;
  fill: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:active .LSU0pgvqnZngjNPf_M_w {
  transition: all 0.3s;
  color: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:active > svg {
  transition: all 0.3s;
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:active > svg * {
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:disabled {
  transition: all 0.3s;
  cursor: not-allowed;
  border-color: #382a50;
  background-color: rgba(50, 50, 50, 0.8);
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:disabled .BD0VPg9ijoauKEKRiaZS svg {
  transition: all 0.3s;
  fill: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:disabled .BD0VPg9ijoauKEKRiaZS svg * {
  transition: all 0.3s;
  fill: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:disabled .LSU0pgvqnZngjNPf_M_w {
  transition: all 0.3s;
  color: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:disabled > svg {
  transition: all 0.3s;
  stroke: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9:disabled > svg * {
  stroke: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9 .BD0VPg9ijoauKEKRiaZS {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9 .BD0VPg9ijoauKEKRiaZS svg {
  transition: all 0.3s;
  fill: #b6b6b6;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9 .BD0VPg9ijoauKEKRiaZS svg * {
  transition: all 0.3s;
  fill: #b6b6b6;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9 .LSU0pgvqnZngjNPf_M_w {
  display: flex;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #fff;
  transition: all 0.3s;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9 > svg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: all 0.3s;
  stroke: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .p36yQsIkKRUGpkahs0_9 > svg * {
  stroke: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .K5KWgw57Dn3p8dTLApv_ {
  transition: all 0.3s;
  border-color: #8d56e8;
  background-color: #2d2d2d;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .K5KWgw57Dn3p8dTLApv_ > svg {
  transition: all 0.3s;
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .K5KWgw57Dn3p8dTLApv_ > svg * {
  stroke: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 {
  position: absolute;
  top: 56px;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  width: calc(100% - 2px);
  border: 1px solid #8d56e8;
  border-radius: 8px;
  overflow: hidden;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i {
  display: flex;
  width: 100%;
  padding: 8px 20px;
  background-color: #2d2d2d;
  transition: all 0.3s;
  border: unset;
  outline: unset;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:hover {
  transition: all 0.3s;
  cursor: pointer;
  background-color: #373737;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:hover .uFQfe8bsNZnyxNqjXvKx {
  transition: all 0.3s;
  color: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:active {
  transition: all 0.3s;
  background-color: #222;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:active .uFQfe8bsNZnyxNqjXvKx {
  transition: all 0.3s;
  color: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:focus {
  transition: all 0.3s;
  background-color: #282828;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:focus .uFQfe8bsNZnyxNqjXvKx {
  transition: all 0.3s;
  color: #fff;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:disabled {
  transition: all 0.3s;
  background-color: #222;
  cursor: not-allowed;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i:disabled .uFQfe8bsNZnyxNqjXvKx {
  transition: all 0.3s;
  color: #636363;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .It1sgjcMfcvv0fAviv7i .uFQfe8bsNZnyxNqjXvKx {
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #ededed;
  transition: all 0.3s;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .WE9vxZBwjMB_nzZUsl3b {
  transition: all 0.3s;
  background-color: #222;
}
.qZKzfHN3Hf6Z8V38BX_Q .CyQeoKtHnHJud0UK0KkN .Jd3tyvxBB5JQw_dF73m3 .WE9vxZBwjMB_nzZUsl3b .uFQfe8bsNZnyxNqjXvKx {
  transition: all 0.3s;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/Dropdown/Dropdown.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAAF;AAEE;EACE,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cCaY;EDZZ,oBAAA;AAAJ;AAGE;EACE,cCqBO;EDpBP,oBAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;AAFJ;AAII;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAII;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,uCAAA;EACA,cAAA;EACA,oBAAA;AAFN;AAIM;EACE,oBAAA;EACA,eAAA;EACA,qBCzCK;ED0CL,yBCEO;ADJf;AAIQ;EACE,oBAAA;EACA,aCrBC;ADmBX;AAIU;EACE,oBAAA;EACA,aCzBD;ADuBX;AAMQ;EACE,oBAAA;EACA,cC/BC;AD2BX;AAOQ;EACE,oBAAA;EACA,YCpDF;AD+CR;AAOU;EACE,YCvDJ;ADkDR;AAUM;EACE,oBAAA;EACA,eAAA;EACA,qBCtEK;EDuEL,yBC7BO;ED8BP,cAAA;AARR;AAUQ;EACE,oBAAA;EACA,UCrEF;AD6DR;AAUU;EACE,oBAAA;EACA,UCzEJ;ADiER;AAYQ;EACE,oBAAA;EACA,WC/EF;ADqER;AAaQ;EACE,oBAAA;EACA,YCpFF;ADyER;AAaU;EACE,YCvFJ;AD4ER;AAgBM;EACE,oBAAA;EACA,eAAA;EACA,qBCzGK;ED0GL,uCAAA;AAdR;AAgBQ;EACE,oBAAA;EACA,UCpGF;ADsFR;AAgBU;EACE,oBAAA;EACA,UCxGJ;AD0FR;AAkBQ;EACE,oBAAA;EACA,WC9GF;AD8FR;AAmBQ;EACE,oBAAA;EACA,YCnHF;ADkGR;AAmBU;EACE,YCtHJ;ADqGR;AAsBM;EACE,oBAAA;EACA,mBAAA;EACA,qBCjIK;EDkIL,uCAAA;AApBR;AAsBQ;EACE,oBAAA;EACA,aCjHC;AD6FX;AAsBU;EACE,oBAAA;EACA,aCrHD;ADiGX;AAwBQ;EACE,oBAAA;EACA,cC3HC;ADqGX;AAyBQ;EACE,oBAAA;EACA,eChIC;ADyGX;AAyBU;EACE,eCnID;AD4GX;AA4BM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AA1BR;AA4BQ;EACE,oBAAA;EACA,aC9JM;ADoIhB;AA4BU;EACE,oBAAA;EACA,aClKI;ADwIhB;AA+BM;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WCnLA;EDoLA,oBAAA;AA7BR;AAgCM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eC5KG;AD8IX;AAgCQ;EACE,eC/KC;ADiJX;AAmCI;EACE,oBAAA;EACA,qBC/MO;EDgNP,yBCtKS;ADqIf;AAmCM;EACE,oBAAA;EACA,YC7MA;AD4KR;AAmCQ;EACE,YChNF;AD+KR;AAsCI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AApCN;AAsCM;EACE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,yBClMO;EDmMP,oBAAA;EACA,aAAA;EACA,cAAA;AApCR;AAsCQ;EACE,oBAAA;EACA,eAAA;EACA,yBCrMK;ADiKf;AAsCU;EACE,oBAAA;EACA,WCjPJ;AD6MR;AAwCQ;EACE,oBAAA;EACA,sBChOF;AD0LR;AAwCU;EACE,oBAAA;EACA,WC3PJ;ADqNR;AA0CQ;EACE,oBAAA;EACA,yBCpOE;AD4LZ;AA0CU;EACE,oBAAA;EACA,WCrQJ;AD6NR;AA4CQ;EACE,oBAAA;EACA,sBCpPF;EDqPE,mBAAA;AA1CV;AA4CU;EACE,oBAAA;EACA,cC9PD;ADoNX;AA8CQ;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cCnRM;EDoRN,oBAAA;AA5CV;AAgDM;EACE,oBAAA;EACA,sBC3QA;AD6NR;AAgDQ;EACE,oBAAA;EACA,WCtSF;ADwPR","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `qZKzfHN3Hf6Z8V38BX_Q`,
	"label": `pdLS1SWFuicmf7uTX8kk`,
	"disabledLabel": `ZfTUrMofTNFgwIc25nLN`,
	"dropdown": `CyQeoKtHnHJud0UK0KkN`,
	"badge": `QcLou3TloqllSwfUynMK`,
	"selector": `p36yQsIkKRUGpkahs0_9`,
	"icon": `BD0VPg9ijoauKEKRiaZS`,
	"selectedOptionLabel": `LSU0pgvqnZngjNPf_M_w`,
	"selectorWithOpenedMenu": `K5KWgw57Dn3p8dTLApv_`,
	"optionsMenu": `Jd3tyvxBB5JQw_dF73m3`,
	"optionItem": `It1sgjcMfcvv0fAviv7i`,
	"optionItemLabel": `uFQfe8bsNZnyxNqjXvKx`,
	"selectedItem": `WE9vxZBwjMB_nzZUsl3b`
};
export default ___CSS_LOADER_EXPORT___;
